<template>
    <div class="dateTimeRangePicker">
        <el-date-picker :zIndex="zIndex" :disabled='disabled' v-model="value" :type="datePickerType" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="center" :size="'small'" :default-time="defaultTime" @change="changeTime" :clearable="clearable" :editable="false">
        </el-date-picker>
    </div>
</template>
<script>
import Vue from "vue";
import dayjs from 'dayjs';
import "element-ui/lib/theme-chalk/date-picker.css"
import "element-ui/lib/theme-chalk/icon.css"

import {
    DatePicker,
    TimeSelect,
    TimePicker
} from 'element-ui/lib/element-ui.common.js';
// console.log(DatePicker);
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)


export default {
    name: 'dateTimeRangePicker',
    props: {
        clearable: {
            type: Boolean,
            default: false,
        },
        currSelectDate: {
            type: Object,
            required: true,
        },
        datePickerType: {
            type: String,
            required: false,
            default: 'datetimerange' // datetimerange-日期时间范围选择;daterange-日期范围选择
        },
        isCurTimeAsEndTime: { // 是否使用当前时间最为结束时间
            type: Boolean,
            required: false,
            default: false
        },
        disabledEndDate: { //自定义最大时间
            type: String,
            required: false,
        },
        disabled: { // 是否禁用
            type: Boolean,
            required: false,
            default: false
        },
        maxDays: { //最大时间间隔：天数
            type: Number,
            required: false,
        },
        shortcutKey: { //日历左侧快捷键
            type: Boolean,
            default: true,
        },
        zIndex: { //日期控件的浮层，默认为2000
            type: Number,
            //default: 2000
        }
    },
    data() {
        return {
            defaultTime: ['00:00:00', '23:59:59'],
            value: [],
            // value: (this.currSelectDate.beginday != '' && this.currSelectDate.endday != '') ? [this.currSelectDate.beginday, this.currSelectDate.endday] : [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), new Date()],
        };
    },
    computed: {
        pickerOptions: function() {
            let _this = this;
            if (!this.shortcutKey) return null;
            return {
                disabledDate(time) { //禁用当天23:59:59之后的日期
                    //console.log(_this.disabledEndDate);
                    Date.parse(new Date(_this.disabledEndDate))
                    let timeDifference;
                    let now = new Date().toLocaleDateString() + ' 23:59:59';
                    now = new Date(now).getTime();
                    timeDifference = now - (new Date().getTime());
                    if (_this.disabledEndDate != undefined) {
                        let t = Date.parse(new Date(_this.disabledEndDate));
                        return time.getTime() > t;
                    }
                    return time.getTime() > Date.now() + timeDifference;
                },
                shortcuts: [{
                        text: '近24小时',
                        onClick(picker) {
                            let end = new Date();
                            let start = new Date();
                            //start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            start = new Date(dayjs().add(-24, 'hour').format('YYYY-MM-DD HH:mm:ss'));
                            if (!_this.isCurTimeAsEndTime) {
                                // end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                                end = new Date(dayjs().add(0, 'hour').format('YYYY-MM-DD HH:mm:ss'));
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '当日',
                        onClick(picker) {
                            let end = new Date();
                            let start = new Date();
                            start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            if (!_this.isCurTimeAsEndTime) {
                                end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    // {
                    //     text: '昨日',
                    //     onClick(picker) {
                    //         let end = new Date();
                    //         let start = new Date();
                    //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                    //         end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                    //         start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                    //         end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                    //         picker.$emit('pick', [start, end]);
                    //     }
                    // },
                    {
                        text: '近2日',
                        onClick(picker) {
                            let end = new Date();
                            let start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                            start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            if (!_this.isCurTimeAsEndTime) {
                                end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '近3日',
                        onClick(picker) {
                            let end = new Date();
                            let start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
                            start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            if (!_this.isCurTimeAsEndTime) {
                                end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '近7日',
                        onClick(picker) {
                            let end = new Date();
                            let start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                            start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            if (!_this.isCurTimeAsEndTime) {
                                end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '近30日',
                        onClick(picker) {
                            let end = new Date();
                            let start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
                            start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            if (!_this.isCurTimeAsEndTime) {
                                end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        }
    },
    mounted() {

    },
    methods: {
        /**
         * [changeTime 时间选择后回调]
         * @return {[type]} [description]
         */
        changeTime() {
            let info = this;
            if (this.value == null) {
                this.$emit("update:currSelectDate", {
                    beginDay: '',
                    endDay: '',
                });
                this.$emit('change', this.currSelectDate);
            } else {
                let beginday = new Date(this.value[0]);
                let endday = new Date(this.value[1]);
                beginday = this.formatToStringTime(beginday);
                endday = this.formatToStringTime(endday);
                if (this.maxDays) {
                    let days = dayjs(endday).diff(dayjs(beginday), 'days');
                    if (days > info.maxDays - 1) {
                        info.setVal(info.currSelectDate); //设置回原来的时间
                        info.$msg({
                            type: 'toast',
                            content: '选择时间不能大于' + (info.maxDays) + '天',
                        });
                        return;
                    }
                }
                if (this.datePickerType === 'daterange') {
                    beginday = beginday.split(' ')[0]
                    endday = endday.split(' ')[0]
                }
                this.$emit("update:currSelectDate", {
                    beginDay: beginday,
                    endDay: endday,
                });
                this.$emit('change', this.currSelectDate);
            }
        },
        //根据val设置时间
        setVal(val) {
            if (val.beginDay == '' && val.endDay == '') {
                this.value = null;
            } else {
                this.value = [val.beginDay, val.endDay];
            }
        }
    },
    watch: {
        currSelectDate: {
            handler(newV, oldV) {
                this.setVal(newV);
            },
            deep: true,
        }
    }
};
</script>
<style lang="less" scoped>
@deep: ~'>>>';

.dateTimeRangePicker {
    display: inline-block;
    height: 40px;
    cursor: pointer;
    margin: 0 !important;

    /deep/ .el-date-editor--datetimerange.el-range-editor--small {
        width: 414px;
        height: 40px;
        padding: 3px 0 3px 2px;
        border-radius: 2px;
        border-width: 1px;

        //background:rgba(59,61,80,0.55);
        &:hover {
            border-color: #4d89ff;
        }

        .el-range__close-icon {
            display: none !important;
            width: 0px;
        }
    }

    /deep/ .el-date-editor {
        line-height: 28px;

        //border-color: rgba(59,61,80,0.55);
        .el-range-input {
            width: 148px;
            font-size: 14px;
            //background:rgba(59,61,80,0.55);
            //color:rgba(187,189,199,1);
        }

        .el-range__icon {
            font-size: 18px;
            color: #BCC1CC;
            margin-top: 0px;
            margin-left: 10px;
        }

        /deep/ .el-input__inner {
            line-height: 28px;
            height: 28px;
            //border: 1px solid #DCDFE6;
            //color: #606266;


        }
    }

    &.is-disabled {
        cursor: not-allowed;
    }

    /deep/ .el-range-separator {
        height: 40px !important;
        line-height: 40px !important;
        //color:rgba(187,189,199,1);
    }

    /deep/ input {
        &::placeholder {
            color: #757575 !important;
            font-size: 13px !important;
        }
    }
}
</style>